export default function SimulatorFlex() {
  return (
    <section className="blade-padding-top">
      <section className=" max-w-xl lg:max-w-7xl mx-auto w-11/12 px-2 md:px-4">
        {/* <div className=" card-title font-gilroy text-green font-semibold mb-3 md:mb-7 lg:mb-10 max-w-4xl  md:pl-3 xl:max-w-6xl xxl:max-w-7xl mx-auto">
          EV SIMULATOR
        </div> */}
        <h3 className="text-center font-gilroy">
        Explore VerdeMobility’s on-field EVSE troubleshooting solutions
        </h3>
        {/* <h1 className="sm:block inline leading-tight font-gilroylight md:mb-1 text-center">
        Explore VerdeMobility’s on-field EVSE troubleshooting solutions.
        </h1> */}
        {/* <h2 className="sm:block inline leading-tight font-gilroylight md:mb-1 max-w-4xl xl:max-w-6xl xxl:max-w-7xl mx-auto pl-2">
          <b>intelligence</b> and <b>control.</b>
        </h2>
        <p className="text-[18px] md:text-[22px] lg:text-[28px] xl:text-[38px] leading-snug md:leading-snug lg:leading-snug xl:leading-snug font-poppins font-light max-w-xl lg:max-w-2xl xl:max-w-4xl mx-auto mt-3 md:mt-7 lg:mt-10">
          Explore VerdeMobility’s on-field EVSE troubleshooting solutions.
        </p> */}
      </section>
    </section>
  );
}
